import { createSelector } from 'reselect';

const selectRoute = (state) => state.get('route');
const selectEditor = (state) => state.get('editor');
const selectGlobal = (state) => state.get('global');
const selectNotifications = (state) => state.get('notifications');
const selectModals = (state) => state.get('modal');

const selectVariables = (state) => state.get('EditorNodeview');
const selectChapters = (state) => state.get('EditorNodeview');
const selectNodetree = (state) => state.get('EditorNodeview');

const makeSelectUser = () => createSelector(
  selectGlobal,
  (state) => state.get('user'),
);
const makeSelectExportModal = () => createSelector(
  selectModals,
  (modalState) => modalState.get('exportModal'),
);
const makeSelectNewProjectModal = () => createSelector(
  selectModals,
  (modalState) => modalState.get('newprojectModal'),
);
const makeSelectLoadModal = () => createSelector(
  selectModals,
  (modalState) => modalState.get('loadModal'),
);
const makeSelectDeleteModal = () => createSelector(
  selectModals,
  (modalState) => modalState.get('deleteModal'),
);
const makeSelectDeleteProject = () => createSelector(
  selectModals,
  (modalState) => modalState.get('deleteProject'),
);
const makeSelectNotifications = () => createSelector(
  selectNotifications,
  (notificationState) => notificationState,
);
const makeSelectProjects = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('projects').toJS(),
);
const makeSelectCategories = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('categories').toJS(),
);

const makeSelectLoginFormState = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('formState').toJS(),
);
const makeSelectUploadProgress = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('uploadProgress'),
);
const makeSelectIsUploading = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('isUploading'),
);

const makeSelectActiveProjectData = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('activeProjectData').toJS(),
);

const makeSelectSessionToken = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('session_token'),
);
const makeSelectError = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('error'),
);
const makeSelectSending = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('currentlySending'),
);
const makeSelectLoggedIn = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('loggedIn'),
);

const makeSelectLocation = () => createSelector(
  selectRoute,
  (routeState) => routeState.get('location').toJS(),
);

const makeSelectVariablesItems = () => createSelector(
  selectVariables,
  (variablesState) => variablesState.getIn(['project', 'variables']),
);

const makeSelectDebugVars = () => createSelector(
  selectNodetree,
  (nodetreeState) => nodetreeState.get('debugvars'),
);

const makeSelectProject = () => createSelector(
  selectNodetree,
  (nodetreeState) => nodetreeState.get('project').toJS(),
);

const makeSelectActiveNodeID = () => createSelector(
  selectNodetree,
  (nodetreeState) => nodetreeState.get('activeNode'),
);

const makeSelectActiveNode = () => createSelector(
  selectNodetree,
  (nodetreeState) => {
    const activeNode = nodetreeState.get('activeNode');
    if (activeNode === false) return false;

    const allNodes = nodetreeState.getIn(['project', 'nodes']);

    return allNodes.find((obj) => obj.toJS().id === activeNode).toJS();
  },
);

const makeSelectChapterItems = () => createSelector(
  selectChapters,
  (chapterState) => chapterState.get('project').get('chapters'),
);

const makeSelectActiveChapter = () => createSelector(
  selectChapters,
  (chapterState) => chapterState.get('project').get('activeChapter'),
);

export {
  selectRoute,
  selectGlobal,
  selectModals,
  selectEditor,
  selectChapters,
  selectNodetree,
  makeSelectLocation,
  makeSelectVariablesItems,
  makeSelectProject,
  makeSelectChapterItems,
  makeSelectActiveChapter,
  makeSelectActiveNodeID,
  makeSelectActiveNode,
  makeSelectLoginFormState,
  makeSelectError,
  makeSelectSending,
  makeSelectLoggedIn,
  makeSelectSessionToken,
  makeSelectUploadProgress,
  makeSelectIsUploading,
  makeSelectActiveProjectData,
  makeSelectProjects,
  makeSelectCategories,
  makeSelectNotifications,
  makeSelectDeleteModal,
  makeSelectDeleteProject,
  makeSelectLoadModal,
  makeSelectNewProjectModal,
  makeSelectExportModal,
  makeSelectUser,
  makeSelectDebugVars,
};



// WEBPACK FOOTER //
// ./src/selectors.js